import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[750px] flex flex-col items-center justify-center overflow-hidden bg-background-50">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Abstract%20ink%20wash%20painting%20style%20with%20dramatic%20dark%20and%20warm%20coral%20splashes%2C%20artistic%20texture%2C%20Japanese%20sumi-e%20inspired%20with%20modern%20twist%2C%20elegant%20chaos%2C%20editorial%20design%20background%2C%20soft%20cream%20base%20with%20expressive%20dark%20ink%20strokes%20and%20subtle%20warm%20orange%20accents&width=1800&height=1000&seq=hero-bg-main&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-background-50" />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 flex flex-col items-center text-center pt-20 pb-16">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/80 backdrop-blur-sm border border-background-200/50 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse" />
          <span className="text-xs text-foreground-700 font-medium tracking-wide">
            实时追踪 · 网红塌房现场
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-foreground-950 leading-tight max-w-3xl">
          吃瓜网<span className="text-accent-500">黑料</span>
        </h1>
        <p className="mt-4 text-lg md:text-xl text-foreground-600 max-w-xl leading-relaxed">
          51吃瓜网黑料网站 —— 聚焦吃瓜网黑料国产精品合集<br />
          一手博主反差视频与网红塌房现场快讯
        </p>

        <div className="flex items-center gap-3 mt-8">
          <Link
            to="/category/wanghong-tafang"
            className="inline-flex items-center px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            最新塌房
            <i className="ri-arrow-right-line ml-1.5" />
          </Link>
          <Link
            to="/category/heiliao-heji"
            className="inline-flex items-center px-6 py-3 rounded-full border-2 border-primary-500 text-primary-500 text-sm font-medium hover:bg-primary-500 hover:text-background-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            黑料合集
          </Link>
        </div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 -mt-4 pb-8">
        <div className="rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20editorial%20composition%20with%20dark%20ink%20splashes%20and%20warm%20coral%20tones%2C%20newspaper%20texture%20overlay%2C%20mystery%20and%20revelation%20theme%2C%20modern%20artistic%20style%2C%20soft%20cream%20background%20with%20expressive%20marks&width=1400&height=600&seq=hero-bottom-banner&orientation=landscape"
            alt="吃瓜网黑料 - 网红塌房爆料现场"
            className="w-full h-auto object-cover"
            title="吃瓜网黑料 - 51吃瓜网黑料网站 爆料现场"
          />
        </div>
      </div>
    </section>
  );
}